"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartAccount_v100__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IEntryPoint",
                name: "anEntryPoint",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "smartAccount",
                type: "address",
            },
        ],
        name: "AlreadyInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseImplementationCannotBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "CallerIsNotAnEntryPoint",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "CallerIsNotEntryPointOrOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "CallerIsNotOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "CallerIsNotSelf",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "targetTxGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "gasPrice",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        name: "CanNotEstimateGas",
        type: "error",
    },
    {
        inputs: [],
        name: "DelegateCallsOnly",
        type: "error",
    },
    {
        inputs: [],
        name: "EntryPointCannotBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "ExecutionFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "HandlerCannotBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementationAddress",
                type: "address",
            },
        ],
        name: "InvalidImplementation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "restoredSigner",
                type: "address",
            },
            {
                internalType: "address",
                name: "expectedSigner",
                type: "address",
            },
        ],
        name: "InvalidSignature",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "MixedAuthFail",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ModuleAlreadyEnabled",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "expectedModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "returnedModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "prevModule",
                type: "address",
            },
        ],
        name: "ModuleAndPrevModuleMismatch",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ModuleCannotBeZeroOrSentinel",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ModuleNotEnabled",
        type: "error",
    },
    {
        inputs: [],
        name: "ModulesAlreadyInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "ModulesSetupExecutionFailed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLeft",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "gasRequired",
                type: "uint256",
            },
        ],
        name: "NotEnoughGasLeft",
        type: "error",
    },
    {
        inputs: [],
        name: "OwnerCanNotBeSelf",
        type: "error",
    },
    {
        inputs: [],
        name: "OwnerCannotBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "OwnerProvidedIsSame",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyProtectionActivated",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenGasPriceFactorCanNotBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "dest",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenTransferFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferToZeroAddressAttempt",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "destLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "valueLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "funcLength",
                type: "uint256",
            },
        ],
        name: "WrongBatchProvided",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "contractSignature",
                type: "bytes",
            },
        ],
        name: "WrongContractSignature",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "uintS",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "contractSignatureLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "signatureLength",
                type: "uint256",
            },
        ],
        name: "WrongContractSignatureFormat",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "payment",
                type: "uint256",
            },
        ],
        name: "AccountHandlePayment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousHandler",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "handler",
                type: "address",
            },
        ],
        name: "ChangedFallbackHandler",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "DisabledModule",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_scw",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_oldEOA",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_newEOA",
                type: "address",
            },
        ],
        name: "EOAChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "EnabledModule",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "txGas",
                type: "uint256",
            },
        ],
        name: "ExecutionFailure",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ExecutionFromModuleFailure",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ExecutionFromModuleSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "txGas",
                type: "uint256",
            },
        ],
        name: "ExecutionSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "ImplementationUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "ModuleTransaction",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SmartAccountReceivedNativeToken",
        type: "event",
    },
    {
        stateMutability: "nonpayable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "addDeposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signatures",
                type: "bytes",
            },
        ],
        name: "checkSignatures",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "prevModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "disableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "domainSeparator",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "enableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "enum Enum.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "targetTxGas",
                        type: "uint256",
                    },
                ],
                internalType: "struct Transaction",
                name: "_tx",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "baseGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "gasPrice",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenGasPriceFactor",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "gasToken",
                        type: "address",
                    },
                    {
                        internalType: "address payable",
                        name: "refundReceiver",
                        type: "address",
                    },
                ],
                internalType: "struct FeeRefund",
                name: "refundInfo",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_nonce",
                type: "uint256",
            },
        ],
        name: "encodeTransactionData",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "entryPoint",
        outputs: [
            {
                internalType: "contract IEntryPoint",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "enum Enum.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "targetTxGas",
                        type: "uint256",
                    },
                ],
                internalType: "struct Transaction",
                name: "_tx",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "baseGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "gasPrice",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenGasPriceFactor",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "gasToken",
                        type: "address",
                    },
                    {
                        internalType: "address payable",
                        name: "refundReceiver",
                        type: "address",
                    },
                ],
                internalType: "struct FeeRefund",
                name: "refundInfo",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "signatures",
                type: "bytes",
            },
        ],
        name: "execTransaction",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execTransactionFromModule",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execTransactionFromModuleReturnData",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "enum Enum.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "targetTxGas",
                        type: "uint256",
                    },
                ],
                internalType: "struct Transaction",
                name: "_tx",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "baseGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "gasPrice",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenGasPriceFactor",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "gasToken",
                        type: "address",
                    },
                    {
                        internalType: "address payable",
                        name: "refundReceiver",
                        type: "address",
                    },
                ],
                internalType: "struct FeeRefund",
                name: "refundInfo",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "signatures",
                type: "bytes",
            },
        ],
        name: "execTransaction_S6W",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "dest",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "value",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "func",
                type: "bytes[]",
            },
        ],
        name: "executeBatchCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "dest",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "value",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "func",
                type: "bytes[]",
            },
        ],
        name: "executeBatchCall_4by",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dest",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "func",
                type: "bytes",
            },
        ],
        name: "executeCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dest",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "func",
                type: "bytes",
            },
        ],
        name: "executeCall_s1m",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getFallbackHandler",
        outputs: [
            {
                internalType: "address",
                name: "_handler",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getImplementation",
        outputs: [
            {
                internalType: "address",
                name: "_implementation",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "start",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "pageSize",
                type: "uint256",
            },
        ],
        name: "getModulesPaginated",
        outputs: [
            {
                internalType: "address[]",
                name: "array",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "next",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "batchId",
                type: "uint256",
            },
        ],
        name: "getNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "targetTxGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "baseGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "gasPrice",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenGasPriceFactor",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "gasToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "refundReceiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_nonce",
                type: "uint256",
            },
        ],
        name: "getTransactionHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasUsed",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "baseGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "gasPrice",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenGasPriceFactor",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "gasToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "refundReceiver",
                type: "address",
            },
        ],
        name: "handlePaymentRevert",
        outputs: [
            {
                internalType: "uint256",
                name: "requiredGas",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_handler",
                type: "address",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "isModuleEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_dataHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "dest",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "pullTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "requiredTxGas",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "handler",
                type: "address",
            },
        ],
        name: "setFallbackHandler",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newOwner",
                type: "address",
            },
        ],
        name: "setOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "dest",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_implementation",
                type: "address",
            },
        ],
        name: "updateImplementation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct UserOperation",
                name: "userOp",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "missingAccountFunds",
                type: "uint256",
            },
        ],
        name: "validateUserOp",
        outputs: [
            {
                internalType: "uint256",
                name: "validationData",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "withdrawAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawDepositTo",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x60e06040523480156200001157600080fd5b5060405162003915380380620039158339810160408190526200003491620000a1565b60016031553060c052603280546001600160a01b03191673eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee1790556001600160a01b0381166200008b5760405163091748f960e21b815260040160405180910390fd5b6001600160a01b03166080524660a052620000d3565b600060208284031215620000b457600080fd5b81516001600160a01b0381168114620000cc57600080fd5b9392505050565b60805160a05160c0516137e86200012d60003960006102af015260006104ed01526000818161078701528181610dcf01528181610f2c01528181610fd901528181611935015281816119c6015261204f01526137e86000f3fe6080604052600436106102a05760003560e01c80638da5cb5b1161016e578063c399ec88116100cb578063f08a03231161007f578063f698da2511610064578063f698da251461088e578063fc7d3d79146108f7578063ffa1ad741461090a5761031c565b8063f08a03231461084e578063f09a40161461086e5761031c565b8063cc2f8452116100b0578063cc2f8452146107e0578063e009cfde1461080e578063ed516d511461082e5761031c565b8063c399ec88146107ab578063c4ca3a9c146107c05761031c565b8063aaf10f4211610122578063ac85dca711610107578063ac85dca714610743578063affed0e014610763578063b0d691fe146107785761031c565b8063aaf10f421461070f578063abc1b745146107235761031c565b80639e5d4c49116101535780639e5d4c49146106af578063a18f51e5146106cf578063a9059cbb146106ef5761031c565b80638da5cb5b1461066f578063912ccaa31461068f5761031c565b80633a871cdd1161021c5780635229073f116101d0578063610b5925116101b5578063610b5925146105f45780637455ce3c14610614578063856dfd99146106275761031c565b80635229073f146105995780635c0ba299146105c75761031c565b8063468721a711610201578063468721a71461055e5780634a58db191461057e5780634d44560d146105865761031c565b80633a871cdd146105115780633d46b819146105315761031c565b806313af4035116102735780631626ba7e116102585780631626ba7e146104855780632d9ad53d146104be5780633408e470146104de5761031c565b806313af40351461042a578063141a468c1461044a5761031c565b80610772146103825780618f2d146103a457806301ffc9a7146103c4578063025b22bc1461040a5761031c565b3661031c576001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036102ee57604051633c97166560e21b815260040160405180910390fd5b604051349033907ed05ab44e279ac59e855cb75dc2ae23b200ad994797b6f1f028f96a46ecce0290600090a3005b34801561032857600080fd5b507f6c9a6c4a39284e37ed1cf53d337577d14212a4870fb976a4366c693b939918d480548061035357005b36600080373360601b365260008060143601600080855af190503d6000803e8061037c573d6000fd5b503d6000f35b34801561038e57600080fd5b506103a261039d366004612ab2565b610953565b005b3480156103b057600080fd5b506103a26103bf366004612b53565b6109a2565b3480156103d057600080fd5b506103f56103df366004612c03565b6001600160e01b0319166301ffc9a760e01b1490565b60405190151581526020015b60405180910390f35b34801561041657600080fd5b506103a2610425366004612c20565b610ab3565b34801561043657600080fd5b506103a2610445366004612c20565b610bbb565b34801561045657600080fd5b50610477610465366004612c3d565b60336020526000908152604090205481565b604051908152602001610401565b34801561049157600080fd5b506104a56104a0366004612d22565b610cbd565b6040516001600160e01b03199091168152602001610401565b3480156104ca57600080fd5b506103f56104d9366004612c20565b610d8a565b3480156104ea57600080fd5b507f0000000000000000000000000000000000000000000000000000000000000000610477565b34801561051d57600080fd5b5061047761052c366004612d69565b610dc2565b34801561053d57600080fd5b5061047761054c366004612c3d565b60009081526033602052604090205490565b34801561056a57600080fd5b506103f5610579366004612dcc565b610e2b565b6103a2610f2a565b6103a2610594366004612e36565b610faa565b3480156105a557600080fd5b506105b96105b4366004612dcc565b611060565b604051610401929190612eb2565b3480156105d357600080fd5b506105e76105e2366004612fad565b611096565b6040516104019190613005565b34801561060057600080fd5b506103a261060f366004612c20565b6111f0565b6103f5610622366004613018565b611316565b34801561063357600080fd5b507f6c9a6c4a39284e37ed1cf53d337577d14212a4870fb976a4366c693b939918d4545b6040516001600160a01b039091168152602001610401565b34801561067b57600080fd5b50603254610657906001600160a01b031681565b34801561069b57600080fd5b506103a26106aa366004612b53565b611554565b3480156106bb57600080fd5b506103a26106ca366004612ab2565b611562565b3480156106db57600080fd5b506104776106ea36600461308d565b61156e565b3480156106fb57600080fd5b506103a261070a366004612e36565b611707565b34801561071b57600080fd5b503054610657565b34801561072f57600080fd5b5061047761073e3660046130eb565b6117a5565b34801561074f57600080fd5b506103a261075e3660046131b3565b611878565b34801561076f57600080fd5b5061047761190e565b34801561078457600080fd5b507f0000000000000000000000000000000000000000000000000000000000000000610657565b3480156107b757600080fd5b506104776119a6565b3480156107cc57600080fd5b506104776107db3660046131f4565b6119f5565b3480156107ec57600080fd5b506108006107fb366004612e36565b611a6e565b604051610401929190613265565b34801561081a57600080fd5b506103a26108293660046132c2565b611b67565b34801561083a57600080fd5b506103a2610849366004612d22565b611c99565b34801561085a57600080fd5b506103a2610869366004612c20565b611f2b565b34801561087a57600080fd5b506103a26108893660046132c2565b611fa2565b34801561089a57600080fd5b50610477604080517f47e79534a245952e8b16893a336b85a3d9ea9fa8c573f3d803afb92a794692186020820152469181019190915230606082015260009060800160405160208183030381529060405280519060200120905090565b6103f5610905366004613018565b612037565b34801561091657600080fd5b506105e76040518060400160405280600581526020017f312e302e3000000000000000000000000000000000000000000000000000000081525081565b61095b612044565b61099c848484848080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152506120aa92505050565b50505050565b6109aa612044565b8415806109b75750848314155b806109c25750828114155b156109f657604051630a0c0a9160e31b81526004810186905260248101849052604481018290526064015b60405180910390fd5b60005b85811015610aaa57610aa2878783818110610a1657610a166132fb565b9050602002016020810190610a2b9190612c20565b868684818110610a3d57610a3d6132fb565b90506020020135858585818110610a5657610a566132fb565b9050602002810190610a689190613311565b8080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152506120aa92505050565b6001016109f9565b50505050505050565b6032546001600160a01b03163314801590610ace5750333014155b15610aee576040516308a0b0a560e11b81523360048201526024016109ed565b6001600160a01b038116610b445760405162461bcd60e51b815260206004820152601660248201527f416464726573732063616e6e6f74206265207a65726f0000000000000000000060448201526064016109ed565b6001600160a01b0381163b610b7757604051630c76093760e01b81526001600160a01b03821660048201526024016109ed565b308054908290556040516001600160a01b0380841691908316907faa3f731066a578e5f39b4215468d826cdd15373cbc0dfc9cb9bdc649718ef7da90600090a35050565b6032546001600160a01b03163314801590610bd65750333014155b15610bf6576040516308a0b0a560e11b81523360048201526024016109ed565b6001600160a01b038116610c1d57604051639b15e16f60e01b815260040160405180910390fd5b306001600160a01b03821603610c46576040516375b4d24760e01b815260040160405180910390fd5b6032546001600160a01b0390811690821603610c7557604051638a95d3fb60e01b815260040160405180910390fd5b60328054908290556040516001600160a01b0391821691831690829030907ff2c2b1b5312b1e31ad49a7d85acd6322ae6facc51488810b882ecdb4df861cd490600090a45050565b6032546000906001600160a01b03163b15610d4c57603254604051630b135d3f60e11b81526001600160a01b0390911690631626ba7e90610d049086908690600401613358565b602060405180830381865afa158015610d21573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d459190613371565b9050610d84565b610d5683836120c8565b6032546001600160a01b03918216911603610d795750630b135d3f60e11b610d84565b506001600160e01b03195b92915050565b600060016001600160a01b03831614801590610d845750506001600160a01b0390811660009081526020819052604090205416151590565b6000336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610e0f57604051635dac3db760e11b81523360048201526024016109ed565b610e1984846120ec565b9050610e24826122dd565b9392505050565b60003360011480610e525750336000908152602081905260409020546001600160a01b0316155b15610e72576040516321ac7c5f60e01b81523360048201526024016109ed565b610e7f858585855a612328565b90508015610ef6577f8c014e41cffd68ba64f3e7830b8b2e4ee860509d8deab25ebbcbba2f0405e2da3386868686604051610ebe9594939291906133c6565b60405180910390a160405133907f6895c13664aa4f67288b25d7a21d7aaa34916e355fb9b6fae0a139a9085becb890600090a2610f22565b60405133907facd2c8702804128fdb0db2bb49f6d127dd0181c13fd45dbfe16de0930e2bd37590600090a25b949350505050565b7f000000000000000000000000000000000000000000000000000000000000000060405163b760faf960e01b81523060048201526001600160a01b03919091169063b760faf99034906024016000604051808303818588803b158015610f8f57600080fd5b505af1158015610fa3573d6000803e3d6000fd5b5050505050565b6032546001600160a01b03163314610fd75760405163d4ed9a1760e01b81523360048201526024016109ed565b7f000000000000000000000000000000000000000000000000000000000000000060405163040b850f60e31b81526001600160a01b03848116600483015260248201849052919091169063205c287890604401600060405180830381600087803b15801561104457600080fd5b505af1158015611058573d6000803e3d6000fd5b505050505050565b6000606061107086868686610e2b565b915060405160203d0181016040523d81523d6000602083013e8091505094509492505050565b606060007fda033865d68bf4a40a5a7cb4159a99e33dba8569e65ea3e38222eb12d9e66eee60001b856000015186604001518760600151805190602001208860200151896080015189600001518a602001518b604001518c606001518d608001518d6040516020016111139c9b9a99989796959493929190613411565b60408051601f1981840301815291905280516020909101209050601960f81b600160f81b611193604080517f47e79534a245952e8b16893a336b85a3d9ea9fa8c573f3d803afb92a794692186020820152469181019190915230606082015260009060800160405160208183030381529060405280519060200120905090565b6040517fff0000000000000000000000000000000000000000000000000000000000000093841660208201529290911660218301526022820152604281018290526062016040516020818303038152906040529150509392505050565b6111f861242f565b6001600160a01b038116158061121757506001600160a01b0381166001145b156112405760405163cadb248f60e01b81526001600160a01b03821660048201526024016109ed565b6001600160a01b0381811660009081526020819052604090205416156112845760405163b29d459560e01b81526001600160a01b03821660048201526024016109ed565b600060208181527fada5013122d395ba3c54772283fb069b10426056ef8ca54750cb9bb552a59e7d80546001600160a01b0385811680865260408087208054939094166001600160a01b03199384161790935560019095528254168417909155519182527fecdf3a3effea5783a3c4c2140e677577666428d44ed9d474a0b3a4c9943f8440910160405180910390a150565b600060026031540361133b57604051637465d9d160e01b815260040160405180910390fd5b600260315560005a6001600090815260336020527f10f6f77027d502f219862b0303542eb5dd005b06fa23ff4d1775aaa45bbf94778054929350909182916113959189918991908561138c836134a0565b91905055611096565b80516020820120925090506113aa8286611c99565b506113d9603f60068860800151901b6113c391906134b9565b60808801516113d4906109c46134db565b612451565b6113e5906101f46134db565b5a1015611444575a611416603f60068960800151901b61140591906134b9565b60808901516113d4906109c46134db565b611422906101f46134db565b604051633b4daac960e01b8152600481019290925260248201526044016109ed565b61148486600001518760400151886060015189602001518960200151600014611471578a60800151612328565b6109c45a61147f91906134ee565b612328565b92508215801561149657506080860151155b80156114a457506020850151155b156114dd5760808601516020860151604051631061f87f60e31b81526004810192909252602482015283151560448201526064016109ed565b60008560200151600014611545576115145a6114f990856134ee565b8751602089015160408a015160608b015160808c0151612467565b905080827f3fd74c38c9f1b6f0499c6d0128fbf77a796dbacc7eda0369b13006dc977bb56b60405160405180910390a35b50506001603155509392505050565b6110588686868686866109a2565b61099c84848484610953565b6000836000036115c05760405162461bcd60e51b815260206004820152601b60248201527f696e76616c696420746f6b656e4761735072696365466163746f72000000000060448201526064016109ed565b60005a905060006001600160a01b038416156115dc57836115de565b325b90506001600160a01b0385166116615760003a88106115fd573a6115ff565b875b6116098a8c6134db565b6116139190613501565b9050600080600080600085875af190508061165a5760405163190eecf360e31b8152600060048201526001600160a01b0384166024820152604481018390526064016109ed565b50506116c9565b6000868861166f8b8d6134db565b6116799190613501565b61168391906134b9565b9050611690868383612592565b6116c75760405163190eecf360e31b81526001600160a01b03808816600483015283166024820152604481018290526064016109ed565b505b5a82039250826040516020016116e191815260200190565b60408051601f198184030181529082905262461bcd60e51b82526109ed91600401613005565b6032546001600160a01b031633146117345760405163d4ed9a1760e01b81523360048201526024016109ed565b6001600160a01b03821661175b576040516309293b1960e41b815260040160405180910390fd5b600080600080600085875af19050806117a05760405163190eecf360e31b8152600060048201526001600160a01b0384166024820152604481018390526064016109ed565b505050565b6000806040518060a001604052808f6001600160a01b031681526020018b60018111156117d4576117d461338e565b81526020018e81526020018d8d8080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525050509082525060209081018b90526040805160a0810182528b81529182018a905281018890526001600160a01b0380881660608301528616608082015290915061185d828286611096565b80519060200120925050509c9b505050505050505050505050565b6032546001600160a01b031633146118a55760405163d4ed9a1760e01b81523360048201526024016109ed565b6001600160a01b0382166118cc576040516309293b1960e41b815260040160405180910390fd5b6118d7838383612592565b6117a05760405163190eecf360e31b81526001600160a01b03808516600483015283166024820152604481018290526064016109ed565b604051631aab3f0d60e11b8152306004820152600060248201819052906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906335567e1a906044015b602060405180830381865afa15801561197d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119a19190613518565b905090565b6040516370a0823160e01b81523060048201526000906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906370a0823190602401611960565b6000805a9050611a3e878787878080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525089925050505a612328565b611a5b57604051632b3f6d1160e21b815260040160405180910390fd5b5a604080519183036020830152016116e1565b606060008267ffffffffffffffff811115611a8b57611a8b612c56565b604051908082528060200260200182016040528015611ab4578160200160208202803683370190505b506001600160a01b0380861660009081526020819052604081205492945091165b6001600160a01b03811615801590611af757506001600160a01b038116600114155b8015611b0257508482105b15611b595780848381518110611b1a57611b1a6132fb565b6001600160a01b039283166020918202929092018101919091529181166000908152918290526040909120541681611b51816134a0565b925050611ad5565b908352919491935090915050565b611b6f61242f565b6001600160a01b0381161580611b8e57506001600160a01b0381166001145b15611bb75760405163cadb248f60e01b81526001600160a01b03821660048201526024016109ed565b6001600160a01b03828116600090815260208190526040902054811690821614611c1f576001600160a01b0382811660008181526020819052604090819020549051633103525b60e21b815284841660048201529216602483015260448201526064016109ed565b6001600160a01b03818116600081815260208181526040808320805488871685528285208054919097166001600160a01b03199182161790965592849052825490941690915591519081527faab4fa2b463f581b2b32cb3b7e3b704b9ce37cc209b5fb4d77e593ace4054276910160405180910390a15050565b604181511015611ceb5760405162461bcd60e51b815260206004820152601960248201527f496e76616c6964207369676e617475726573206c656e6774680000000000000060448201526064016109ed565b600080600080611d0e856020810151604082015160419092015160ff1692909190565b9195509350915060ff8416600003611e535750816041821015611d55576040516338a245ff60e11b81526004810183905260006024820181905260448201526064016109ed565b6020828601810151865190918290611d6e9086906134db565b611d7891906134db565b1115611dab5785516040516338a245ff60e11b8152600481018590526024810183905260448101919091526064016109ed565b604051630b135d3f60e11b808252878501602001916001600160a01b03851690631626ba7e90611de1908c908690600401613358565b602060405180830381865afa158015611dfe573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e229190613371565b6001600160e01b03191614611e4c578060405163605d348960e01b81526004016109ed9190613005565b5050611ee6565b601e8460ff161115611ed657611ece611e6d600486613531565b8484611ec68a6040517f19457468657265756d205369676e6564204d6573736167653a0a3332000000006020820152603c8101829052600090605c01604051602081830303815290604052805190602001209050919050565b9291906126e3565b509050611ee6565b611ee2868585856126e3565b5090505b6032546001600160a01b03828116911614611058576032546040516310b5d43760e21b81526001600160a01b03808416600483015290911660248201526044016109ed565b611f3361242f565b7f6c9a6c4a39284e37ed1cf53d337577d14212a4870fb976a4366c693b939918d454611f5e826127a7565b816001600160a01b0316816001600160a01b03167f06be9a1bea257286cf2afa8205ed494ca9d6a4b41aa58d04238deebada20fb0c60405160405180910390a35050565b6032546001600160a01b031615611fce576040516393360fbf60e01b81523060048201526024016109ed565b6001600160a01b038216611ff557604051639b15e16f60e01b815260040160405180910390fd5b603280546001600160a01b0319166001600160a01b038416179055612019816127a7565b6120336000604051806020016040528060008152506127f2565b5050565b6000610f22848484611316565b336001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161480159061208857506032546001600160a01b03163314155b156120a8576040516332dbd3c760e11b81523360048201526024016109ed565b565b60008082516020840185875af16040513d6000823e81610fa3573d81fd5b60008060006120d785856128bc565b915091506120e481612901565b509392505050565b600036816120fd6060860186613311565b90925090508015612204576000612117600482848661354a565b61212091613574565b90506361a2b3b760e01b6001600160e01b0319821601612202576000808061214b856004818961354a565b81019061215891906135a4565b6001600160a01b03808416600090815260208190526040902054939650919450925016156121fe57604051631179c1f560e11b81526001600160a01b038416906322f383ea906121ae908c908c90600401613662565b6020604051808303816000875af11580156121cd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906121f19190613518565b9650505050505050610d84565b5050505b505b600061225d856040517f19457468657265756d205369676e6564204d6573736167653a0a3332000000006020820152603c8101829052600090605c01604051602081830303815290604052805190602001209050919050565b90506122ad612270610140880188613311565b8080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525085939250506120c89050565b6032546001600160a01b039081169116146122ce5760019350505050610d84565b50600095945050505050565b50565b80156122da5760405133906000199083906000818181858888f193505050503d806000811461099c576040519150601f19603f3d011682016040523d82523d6000602084013e61099c565b6000600183600181111561233e5761233e61338e565b03612356576000808551602087018986f49050612366565b600080855160208701888a87f190505b80156123cb578360405161237a919061377b565b604051809103902085876001600160a01b03167f81d12fffced46c214dfae8ab8fa0b9f7b69f70c9d500e33f612f2105deb261ee86866040516123be929190613797565b60405180910390a4612426565b836040516123d9919061377b565b604051809103902085876001600160a01b03167f3ddd038f78c876172d5dbfd730b14c9f8692dfa197ef104eaac6df3f85a0874a868660405161241d929190613797565b60405180910390a45b95945050505050565b3330146120a8576040516301478e3360e21b81523360048201526024016109ed565b60008183116124605781610e24565b5090919050565b60008360000361248a5760405163653f35a360e01b815260040160405180910390fd5b60006001600160a01b038316156124a157826124a3565b325b90506001600160a01b038416612523573a86106124c0573a6124c2565b855b6124cc888a6134db565b6124d69190613501565b9150600080600080600086865af190508061251d5760405163190eecf360e31b8152600060048201526001600160a01b0383166024820152604481018490526064016109ed565b50612587565b848661252f898b6134db565b6125399190613501565b61254391906134b9565b9150612550848284612592565b6125875760405163190eecf360e31b81526001600160a01b03808616600483015282166024820152604481018390526064016109ed565b509695505050505050565b60006001600160a01b0384166125ea5760405162461bcd60e51b815260206004820152601d60248201527f746f6b656e2063616e206e6f74206265207a65726f206164647265737300000060448201526064016109ed565b6000846001600160a01b03163b116126445760405162461bcd60e51b815260206004820152601c60248201527f746f6b656e20636f6e747261637420646f65736e27742065786973740000000060448201526064016109ed565b604080516001600160a01b03851660248201526044808201859052825180830390910181526064909101909152602080820180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1663a9059cbb60e01b178152825160009182896127105a03f13d80156126c657602081146126ce57600093506126d9565b8193506126d9565b600051158215171593505b5050509392505050565b6000807f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a083111561271a575060009050600361279e565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa15801561276e573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b0381166127975760006001925092505061279e565b9150600090505b94509492505050565b6001600160a01b0381166127ce5760405163dd449f5f60e01b815260040160405180910390fd5b7f6c9a6c4a39284e37ed1cf53d337577d14212a4870fb976a4366c693b939918d455565b600160009081526020527fada5013122d395ba3c54772283fb069b10426056ef8ca54750cb9bb552a59e7d546001600160a01b0316156128455760405163df8cc4e360e01b815260040160405180910390fd5b600160008181526020527fada5013122d395ba3c54772283fb069b10426056ef8ca54750cb9bb552a59e7d80546001600160a01b03191690911790556001600160a01b038216156120335761289f8260008360015a612328565b6120335760405163032e3a3960e51b815260040160405180910390fd5b60008082516041036128f25760208301516040840151606085015160001a6128e6878285856126e3565b945094505050506128fa565b506000905060025b9250929050565b60008160048111156129155761291561338e565b0361291d5750565b60018160048111156129315761293161338e565b0361297e5760405162461bcd60e51b815260206004820152601860248201527f45434453413a20696e76616c6964207369676e6174757265000000000000000060448201526064016109ed565b60028160048111156129925761299261338e565b036129df5760405162461bcd60e51b815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e6774680060448201526064016109ed565b60038160048111156129f3576129f361338e565b036122da5760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c604482015261756560f01b60648201526084016109ed565b6001600160a01b03811681146122da57600080fd5b8035612a6b81612a4b565b919050565b60008083601f840112612a8257600080fd5b50813567ffffffffffffffff811115612a9a57600080fd5b6020830191508360208285010111156128fa57600080fd5b60008060008060608587031215612ac857600080fd5b8435612ad381612a4b565b935060208501359250604085013567ffffffffffffffff811115612af657600080fd5b612b0287828801612a70565b95989497509550505050565b60008083601f840112612b2057600080fd5b50813567ffffffffffffffff811115612b3857600080fd5b6020830191508360208260051b85010111156128fa57600080fd5b60008060008060008060608789031215612b6c57600080fd5b863567ffffffffffffffff80821115612b8457600080fd5b612b908a838b01612b0e565b90985096506020890135915080821115612ba957600080fd5b612bb58a838b01612b0e565b90965094506040890135915080821115612bce57600080fd5b50612bdb89828a01612b0e565b979a9699509497509295939492505050565b6001600160e01b0319811681146122da57600080fd5b600060208284031215612c1557600080fd5b8135610e2481612bed565b600060208284031215612c3257600080fd5b8135610e2481612a4b565b600060208284031215612c4f57600080fd5b5035919050565b634e487b7160e01b600052604160045260246000fd5b60405160a0810167ffffffffffffffff81118282101715612c8f57612c8f612c56565b60405290565b600082601f830112612ca657600080fd5b813567ffffffffffffffff80821115612cc157612cc1612c56565b604051601f8301601f19908116603f01168101908282118183101715612ce957612ce9612c56565b81604052838152866020858801011115612d0257600080fd5b836020870160208301376000602085830101528094505050505092915050565b60008060408385031215612d3557600080fd5b82359150602083013567ffffffffffffffff811115612d5357600080fd5b612d5f85828601612c95565b9150509250929050565b600080600060608486031215612d7e57600080fd5b833567ffffffffffffffff811115612d9557600080fd5b84016101608187031215612da857600080fd5b95602085013595506040909401359392505050565b803560028110612a6b57600080fd5b60008060008060808587031215612de257600080fd5b8435612ded81612a4b565b935060208501359250604085013567ffffffffffffffff811115612e1057600080fd5b612e1c87828801612c95565b925050612e2b60608601612dbd565b905092959194509250565b60008060408385031215612e4957600080fd5b8235612e5481612a4b565b946020939093013593505050565b60005b83811015612e7d578181015183820152602001612e65565b50506000910152565b60008151808452612e9e816020860160208601612e62565b601f01601f19169290920160200192915050565b8215158152604060208201526000610f226040830184612e86565b600060a08284031215612edf57600080fd5b612ee7612c6c565b90508135612ef481612a4b565b8152612f0260208301612dbd565b602082015260408201356040820152606082013567ffffffffffffffff811115612f2b57600080fd5b612f3784828501612c95565b6060830152506080820135608082015292915050565b600060a08284031215612f5f57600080fd5b612f67612c6c565b90508135815260208201356020820152604082013560408201526060820135612f8f81612a4b565b60608201526080820135612fa281612a4b565b608082015292915050565b600080600060e08486031215612fc257600080fd5b833567ffffffffffffffff811115612fd957600080fd5b612fe586828701612ecd565b935050612ff58560208601612f4d565b915060c084013590509250925092565b602081526000610e246020830184612e86565b600080600060e0848603121561302d57600080fd5b833567ffffffffffffffff8082111561304557600080fd5b61305187838801612ecd565b94506130608760208801612f4d565b935060c086013591508082111561307657600080fd5b5061308386828701612c95565b9150509250925092565b60008060008060008060c087890312156130a657600080fd5b8635955060208701359450604087013593506060870135925060808701356130cd81612a4b565b915060a08701356130dd81612a4b565b809150509295509295509295565b6000806000806000806000806000806000806101608d8f03121561310e57600080fd5b6131188d35612a4b565b8c359b5060208d01359a5067ffffffffffffffff60408e0135111561313c57600080fd5b61314c8e60408f01358f01612a70565b909a50985061315d60608e01612dbd565b975060808d0135965060a08d0135955060c08d0135945060e08d013593506101008d013561318a81612a4b565b92506131996101208e01612a60565b91506101408d013590509295989b509295989b509295989b565b6000806000606084860312156131c857600080fd5b83356131d381612a4b565b925060208401356131e381612a4b565b929592945050506040919091013590565b60008060008060006080868803121561320c57600080fd5b853561321781612a4b565b945060208601359350604086013567ffffffffffffffff81111561323a57600080fd5b61324688828901612a70565b9094509250613259905060608701612dbd565b90509295509295909350565b604080825283519082018190526000906020906060840190828701845b828110156132a75781516001600160a01b031684529284019290840190600101613282565b5050506001600160a01b039490941692019190915250919050565b600080604083850312156132d557600080fd5b82356132e081612a4b565b915060208301356132f081612a4b565b809150509250929050565b634e487b7160e01b600052603260045260246000fd5b6000808335601e1984360301811261332857600080fd5b83018035915067ffffffffffffffff82111561334357600080fd5b6020019150368190038213156128fa57600080fd5b828152604060208201526000610f226040830184612e86565b60006020828403121561338357600080fd5b8151610e2481612bed565b634e487b7160e01b600052602160045260246000fd5b600281106133c257634e487b7160e01b600052602160045260246000fd5b9052565b60006001600160a01b03808816835280871660208401525084604083015260a060608301526133f860a0830185612e86565b905061340760808301846133a4565b9695505050505050565b6000610180820190508d82526001600160a01b03808e1660208401528c60408401528b6060840152613446608084018c6133a4565b8960a08401528860c08401528760e08401528661010084015280861661012084015280851661014084015250826101608301529d9c50505050505050505050505050565b634e487b7160e01b600052601160045260246000fd5b6000600182016134b2576134b261348a565b5060010190565b6000826134d657634e487b7160e01b600052601260045260246000fd5b500490565b80820180821115610d8457610d8461348a565b81810381811115610d8457610d8461348a565b8082028115828204841417610d8457610d8461348a565b60006020828403121561352a57600080fd5b5051919050565b60ff8281168282160390811115610d8457610d8461348a565b6000808585111561355a57600080fd5b8386111561356757600080fd5b5050820193919092039150565b6001600160e01b0319813581811691600485101561359c5780818660040360031b1b83161692505b505092915050565b6000806000606084860312156135b957600080fd5b83356135c481612a4b565b925060208401359150604084013567ffffffffffffffff8111156135e757600080fd5b61308386828701612c95565b6000808335601e1984360301811261360a57600080fd5b830160208101925035905067ffffffffffffffff81111561362a57600080fd5b8036038213156128fa57600080fd5b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b604081526136836040820161367685612a60565b6001600160a01b03169052565b60208301356060820152600061369c60408501856135f3565b6101608060808601526136b46101a086018385613639565b92506136c360608801886135f3565b9250603f19808786030160a08801526136dd858584613639565b9450608089013560c088015260a089013560e0880152610100935060c089013584880152610120915060e089013582880152610140848a013581890152613726838b018b6135f3565b9550925081888703018489015261373e868685613639565b955061374c818b018b6135f3565b955093505080878603016101808801525050613769838383613639565b93505050508260208301529392505050565b6000825161378d818460208701612e62565b9190910192915050565b604081016137a582856133a4565b826020830152939250505056fea26469706673582212206d38de10695d463253620f7bec76e681851e44f22392d864735b57ecaf843b1d64736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class SmartAccount_v100__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(anEntryPoint, overrides) {
        return super.deploy(anEntryPoint, overrides || {});
    }
    getDeployTransaction(anEntryPoint, overrides) {
        return super.getDeployTransaction(anEntryPoint, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SmartAccount_v100__factory = SmartAccount_v100__factory;
SmartAccount_v100__factory.bytecode = _bytecode;
SmartAccount_v100__factory.abi = _abi;
//# sourceMappingURL=SmartAccount_v100__factory.js.map